import L from "leaflet";

/** URL officielle OSM (politique tuiles). Surcharge possible via VUE_APP_MAP_TILE_URL. */
export const DEFAULT_MAP_TILE_URL =
  "https://tile.openstreetmap.org/{z}/{x}/{y}.png";

export function getMapTileUrl(): string {
  const fromEnv = process.env.VUE_APP_MAP_TILE_URL;
  if (fromEnv && fromEnv.trim().length > 0) {
    return fromEnv.trim();
  }
  return DEFAULT_MAP_TILE_URL;
}

/** Attribution visible + lien « Signaler un problème » (recommandé OSM). */
export function getOsmMapAttribution(): string {
  return (
    '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors | ' +
    '<a href="https://www.openstreetmap.org/fixthemap" target="_blank" rel="noopener noreferrer">Signaler un problème sur la carte</a>'
  );
}

type TileLayerOptionsWithReferrer = L.TileLayerOptions & {
  referrerPolicy?: string;
};

/** Fond de carte raster conforme à la politique tuiles OSM (HTTPS, Referer, attribution). */
export function addBasemapTileLayer(map: L.Map): L.TileLayer {
  const options: TileLayerOptionsWithReferrer = {
    attribution: getOsmMapAttribution(),
    maxZoom: 19,
    referrerPolicy: "strict-origin-when-cross-origin",
  };

  return L.tileLayer(getMapTileUrl(), options).addTo(map);
}
